export const ContractStatus = {
    PendingSigning: 'In afwachting van ondertekening'
}
